import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { AgencyCreatePayload } from "../../../../Schema/agencyCreate.types";
import { agencyListActions } from "../agencyList/agencyList";

export type UpdateAgencyLoadAction = {
  type: string;
  payload: AgencyCreatePayload;
};

export type UpdateAgencyData = {
  data: {
    message?: string;
    status?: string;
    agency?: { username: string };
  };
};

const UpdateAgency = new ReduxFetchState<UpdateAgencyData | null, AgencyCreatePayload, any>(
  "updateAgency",
);

const RESET_CREATE_AGENCY = "RESET_CREATE_AGENCY";
export function* watchUpdateAgency(action: UpdateAgencyLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: UpdateAgencyData = yield axios({
      url: `/api/v1/ai/agencies/${action.payload.id}`,
      method: "PUT",
      headers: {
        lang,
      },
      data: { ...action.payload, logo_path: action.payload.logo },
    });

    window.open(`/agency/${action.payload.username}`, "_self");
    yield alert({
      message: data.data.message ?? "تغییرات شما با موفقیت ذخیره شد.",
      type: "success",
    });
    yield put(UpdateAgency.actions.loadSuccess({ data: { ...data.data, status: "success" } }));
    yield put(agencyListActions.load());
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? e?.response?.data?.message ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(UpdateAgency.actions.loadFailure(e.message));
  }
}

export function* updateAgencySagas() {
  yield takeEvery(UpdateAgency.actionTypes.load, watchUpdateAgency);
}

const initialState = UpdateAgency.reducer(undefined, { type: "@@INIT" });

const customReducer = (state = initialState, action: any) => {
  if (action.type === RESET_CREATE_AGENCY) {
    return initialState;
  }
  return UpdateAgency.reducer(state, action);
};

export function useUpdateAgency() {
  const { loading, data, ...updateAgencyState } = useAppSelector((state) => state.updateAgency);
  const dispatch = useAppDispatch();

  const dispatchUpdateAgency = useCallback(
    (payload: AgencyCreatePayload) => {
      dispatch(UpdateAgency.actions.load(payload));
    },
    [dispatch],
  );

  const clearUpdateAgency = useCallback(() => {
    dispatch({ type: RESET_CREATE_AGENCY });
  }, [dispatch]);

  return {
    ...updateAgencyState,
    dispatchUpdateAgency,
    clearUpdateAgency,
    updateAgencyLoading: loading,
    updateAgencyData: data,
  };
}

export const { actionTypes: updateAgencyActionsTypes, actions: updateAgencyActions } = UpdateAgency;

export const updateAgencyReducer = customReducer;